module.exports = __webpack_public_path__ + "img/person1.f65d6849.png";